// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605180935/js/" + chunkId + "." + {"44":"0642881a","225":"a206f961","481":"d9b9c8b4","486":"fe09a712","770":"0431f590"}[chunkId] + ".0.4683230115889343.chunk.js";
};